import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { GuaranteeNotes } from "@app/models/guarantee-notes";
import { GuaranteeAgreementNotesService } from "@app/services/guarantee-agreement-notes.service";

@Component({
    selector: "app-select-guarantee-note-popup",
    templateUrl: "./select-guarantee-note-popup.component.html",
    styleUrls: ["./select-guarantee-note-popup.component.css"],
    standalone: false
})
export class SelectGuaranteeNotePopupComponent implements OnInit {
  @Input() guaranteeNotes: Array<GuaranteeNotes>;
  @Input() displaySearchDialog: boolean;
  @Input() selectedGuaranteeNotes: Array<GuaranteeNotes>;
  @Output() onSubmit = new EventEmitter<Array<GuaranteeNotes>>();
  @Output() onCancel = new EventEmitter();

  constructor(private guaranteeNotesService: GuaranteeAgreementNotesService) {}

  ngOnInit() {
    if (!this.selectedGuaranteeNotes) {
      this.selectedGuaranteeNotes = [];
    }
  }

  hideSearch() {
    this.onCancel.emit();
  }

  onSelect(guaranteeNote) {
    if (guaranteeNote) {
      const parentIds = this.guaranteeNotesService.findGuaranteeNoteParents(guaranteeNote, this.guaranteeNotes);
      this.selectedGuaranteeNotes = [
        ...this.selectedGuaranteeNotes.filter((p) => !this.checkIfParentIdInTheList(parentIds, p)),
      ];
      this.selectedGuaranteeNotes.push(guaranteeNote);
    }
  }

  onSave() {
    this.onSubmit.emit(this.selectedGuaranteeNotes);
  }

  deleteSelectedGuaranteeNote(guaranteeNote) {
    if (guaranteeNote) {
      var children = this.findAllChidren(guaranteeNote);
      this.selectedGuaranteeNotes = this.selectedGuaranteeNotes.filter((item) => !children.find((p) => p.id == item.id));

      if (guaranteeNote.parentId) {
        var parent = this.guaranteeNotesService.findGuaranteeNoteById(guaranteeNote.parentId, this.guaranteeNotes);
        this.selectedGuaranteeNotes.push(parent);
      }
    }
  }

  checkIfParentIdInTheList(checkArray: GuaranteeNotes[], guaranteeNote: GuaranteeNotes) {
    const set1 = new Set(checkArray);
    const parents = this.guaranteeNotesService.findGuaranteeNoteParents(guaranteeNote, this.guaranteeNotes);
    for (const element of parents) {
      if (set1.has(element)) {
        return true;
      }
    }
    return false;
  }

  findAllChidren(guaranteeNote: GuaranteeNotes) {
    var items = [];
    if (guaranteeNote) {
      items.push(guaranteeNote);
      if (guaranteeNote.subGuaranteeNotes && guaranteeNote.subGuaranteeNotes.length > 0) {
        guaranteeNote.subGuaranteeNotes.forEach((p) => {
          items = items.concat(this.findAllChidren(p));
        });
      }
    }
    return items;
  }
}
